module.exports = __webpack_public_path__ + "img/11.9cecbde8.png";